module.exports = __webpack_public_path__ + "img/申报征集.2067c506.png";